var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 6,
  height: 11,
  viewBox: "0 0 6 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M.936 10.065 0 9.13l4.087-4.087L0 .954.936 0l5.06 5.042z"
})));
export default SvgRightArrow;